import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/WashWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../../QestIds';
import { WashingProcedure } from 'Components/Worksheets/WashWorksheet/types';
import getMeasuredUsingConfig from '../../../measuredUsingConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.WashingProcedure`]: {
        options: [
          { label: 'A - Plain water', value: WashingProcedure.WashWithPlainWater },
          { label: 'B - With wetting agent', value: WashingProcedure.WashWithWaterAndAgent },
        ],
      },
      [`${prefix}.Results.PercentPassingWashingSieve`]: { format: { nearest: 0.1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.InitialBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Equipment.WashedBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
    }
  );

export default {
  [qestIds.wash.ASTM_C117.rev2017]: getConfig,
  [qestIds.wash.AASHTO_T_11.rev2020]: getConfig,
};
